// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_jg-0";
export var fileCarousel = "_jg-2";
export var removeFileButton = "_jg-1";